import request from "@/common/request"
import { Page } from "@/models"
import { BaixaDePagamento, BaixaDePagamentoForm } from "@/models/financeiro/BaixaDePagamento"
import { AxiosRequestConfig } from "axios"

const basePath = '/baixaDePagamento'

export const findBaixaDePagamento = async (params?: any, config?: AxiosRequestConfig): Promise<Page<BaixaDePagamento>> =>
	request.get(`${basePath}`, { params, ...config })

export const create = async (baixa: BaixaDePagamentoForm): Promise<BaixaDePagamento> =>
	request.post(`${basePath}`, baixa)

export const deleteById = async (id: string): Promise<void> =>
	request.delete(`${basePath}/${id}`)